import { Injectable } from "@angular/core";

import { CoreContentState } from "../state";

import { Icon, IconState } from "./icon.model";

/**
 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
 */
@Injectable({
	providedIn: "root",
})
export class IconSelector {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
	 */
	getState() {
		return (state: CoreContentState): IconState => state.icon;
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcon_v2)" instead
	 */
	get(name: string) {
		return (state: CoreContentState): Icon[] => state.icon.icons[name];
	}

	isBusy() {
		return (state: CoreContentState): boolean => state.icon.isBusy;
	}
}
